module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/@yxl/libs/~/axios/index.js
// module id = HQe3
// module chunks = 0